import axios from "axios";
import { customStorage } from "@/service/customStorage";
import { apiUrl } from "./user.service";
import { router } from "./router";

const apiInstance = axios.create();

apiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    try {
      const originalRequest = error.config;

      if (error?.response?.data?.message) {
        console.error("Error:", error.response.data.message);
      } else {
        console.error("Error:", error);
      }

      if (error.code === "ERR_NETWORK") {
        console.error("Сервер временно недоступен. Проверьте соединение.");
      }

      if (error?.response?.data?.violations) {
        console.error("Violations:", error.response.data.violations);
      }

      if (
        error?.response?.status === 401 &&
        !originalRequest._retry &&
        !originalRequest.url.endsWith("auth/refresh_token")
      ) {
        originalRequest._retry = true;
        const resp = await customAxios.refreshAccessToken();
        if (resp.status === 201) {
          console.log("Новые токены получены");
          customAxios.setNewTokens(resp.data.accessToken, resp.data.refreshToken);
          originalRequest.headers.Authorization = `Bearer ${resp.data.accessToken}`;
          return apiInstance(originalRequest);
        }
      }

      if (
        (originalRequest.url.endsWith("auth/refresh_token") &&
          [401, 403].includes(error?.response?.status))
      ) {
        console.error("Токен не действителен. Перенаправление на логин.");
        localStorage.removeItem("app-user-token");
        localStorage.removeItem("app-refresh-token");
        localStorage.removeItem("app-navigator-user");
        router.push("/auth/login");
      }

      return Promise.reject(error);
    } catch (err) {
      console.error("Ошибка в обработке ошибки:", err);
      return Promise.reject(error);
    }
  }
);

class HTTPService {
  constructor(http, baseUrl) {
    this.http = http;
    this.baseUrl = baseUrl;
  }

  get authorization() {
    const user = JSON.parse(localStorage.getItem("app-navigator-user")) || null;
    const token = user ? localStorage.getItem("app-user-token") : "";
    return user ? { Authorization: `Bearer ${token}` } : {};
  }

  setUser(user) {
    this.user = user;
  }

  getHeaders() {
    return { ...this.authorization };
  }

  get(path, options = {}) {
    return this.http.get(this.baseUrl + path, {
      ...options,
      headers: this.getHeaders(),
    });
  }

  getExternal(path, options = {}) {
    return this.http.get(path, {
      ...options,
      headers: this.getHeaders(),
    });
  }

  post(path, data, options = {}) {
    return this.http.post(this.baseUrl + path, data, {
      ...options,
      headers: this.getHeaders(),
    });
  }

  postExternal(path, data, options = {}) {
    return this.http.post(path, data, {
      ...options,
      headers: this.getHeaders(),
    });
  }

  put(path, data) {
    return this.http.put(this.baseUrl + path, data, {
      headers: this.getHeaders(),
    });
  }

  delete(path) {
    return this.http.delete(this.baseUrl + path, {
      headers: this.getHeaders(),
    });
  }

  refreshAccessToken() {
    const refreshToken = localStorage.getItem("app-refresh-token");
    if (!refreshToken) {
      router.push("/auth/login");
      return Promise.reject(new Error("Refresh token not found"));
    }
    return this.post("auth/refresh_token", {
      refreshToken,
    });
  }

  setNewTokens(newAccessToken, newRefreshToken) {
    customStorage.set("user-token", newAccessToken);
    customStorage.set("refresh-token", newRefreshToken);
  }
}

export const customAxios = new HTTPService(apiInstance, apiUrl);